import { render, staticRenderFns } from "./VersionActions.vue?vue&type=template&id=4eff6e00&scoped=true&"
import script from "./VersionActions.vue?vue&type=script&lang=js&"
export * from "./VersionActions.vue?vue&type=script&lang=js&"
import style0 from "./VersionActions.vue?vue&type=style&index=0&id=4eff6e00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eff6e00",
  null
  
)

export default component.exports